<div
    fxFlex
    fxLayout="row"
    fxLayoutAlign="start start"
    fxLayout.lt-md="column"
    fxLayoutAlign.lt-md="start center"
>
    <div>
        <table class="simple">
            <thead>
                <tr>
                    <th>#</th>
                    <th>
                        Zonas de cobertura
                        <button
                            *ngIf="
                                _menuUsuarioSrvc.esSupervisor() && !eliminado
                            "
                            mat-icon-button
                            color="accent"
                            (click)="agregarZonaCobertura()"
                        >
                            <mat-icon>add</mat-icon>
                        </button>
                    </th>
                    <th class="text-right"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let comuna of comunas; let idx = index">
                    <td>{{ idx + 1 }}</td>
                    <td>
                        <span class="text-bold">{{ comuna.nombre }}</span>
                    </td>
                    <td>
                        <button
                            *ngIf="
                                _menuUsuarioSrvc.esSupervisor() && !eliminado
                            "
                            mat-icon-button
                            color="warn"
                            (click)="eliminar(comuna)"
                        >
                            <mat-icon>delete_forever</mat-icon>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
        <p *ngIf="comunas.length === 0">
            Sin zonas de cobertura por el momento
        </p>
    </div>
</div>
